import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { Spinner } from 'reactstrap'

import { getSharesForRedemptionState } from 'models/General/selectors'
import { getCategories, getIsFetchingRewards } from 'models/Rewards/selectors'
import { STRING } from 'resources'
import { APP_URLS } from 'resources/urls'

import RewardCategoryItem from './RewardCategoryItem'
import RewardsCategoryDetails from './RewardsCategoryDetails'

import { GridContainer, SpinnerContainer } from './styles'

const REWARDS_CATEGORIES_COLUMNS = 3

const RewardsCategories = () => {
  const history = useHistory()
  const location = useLocation()

  const categories = useSelector(getCategories)
  const sharesForRedemptionState = useSelector(getSharesForRedemptionState)
  const isFetchingRewards = useSelector(getIsFetchingRewards)

  const selectedCategory = location.state?.selectedCategory || null

  const handleRewardCategoryPress = useCallback(
    (category) => {
      if (category.name === STRING.redemptionStore.shares.categoryName) {
        history.push(APP_URLS.SHARES_FOR_REDEMPTION)
      } else {
        history.replace({ ...history.location, state: { selectedCategory: category } })
      }
    },
    [history],
  )

  const content = useMemo(() => {
    if (isFetchingRewards) {
      return (
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      )
    }

    if (selectedCategory) {
      return <RewardsCategoryDetails selectedCategory={selectedCategory} />
    }

    return (
      <GridContainer columns={REWARDS_CATEGORIES_COLUMNS}>
        {categories.map((category) => {
          if (
            category.name === STRING.redemptionStore.shares.categoryName &&
            !['on', 'closed'].includes(sharesForRedemptionState)
          ) {
            return null
          }
          return (
            <RewardCategoryItem
              key={category.id}
              category={category}
              columns={REWARDS_CATEGORIES_COLUMNS}
              onClick={() => handleRewardCategoryPress(category)}
            />
          )
        })}
      </GridContainer>
    )
  }, [isFetchingRewards, selectedCategory, categories, sharesForRedemptionState, handleRewardCategoryPress])

  return content
}

export default RewardsCategories
